import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconInfoSvg } from "./IconInfoSvg.mjs";
const IconInfo = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconInfoSvg, ...svgProps }) });
export {
  IconInfo
};
